<template>
    <v-row no-gutters>
        <v-col
                cols="12"
        >
            <v-data-table
                    :headers="ticket_type_headers"
                    :items="ticket_types"
                    class="elevation-1"
                    :loading="loading"
                    :loading-text="$t('Loading')"
                    item-key="pk"
                    show-expand
            >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>{{ $tc('TicketType', 3) }}</v-toolbar-title>
                        <v-divider
                                class="mx-4"
                                inset
                                vertical
                        ></v-divider>
                        <v-spacer></v-spacer>
                        <v-dialog
                            v-model="dialog"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn color="primary" dark class="mb-2" v-on="on">{{ $t('NewTicketType') }}</v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-text-field v-model="editedItem.min_age" :label="$t('MinAge')"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-text-field v-model="editedItem.max_age" :label="$t('MaxAge')"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-text-field v-model="editedItem.price" :label="$t('Price')"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-text-field v-model="editedItem.vat_percentage" :label="$t('VATWithUnit')"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-card>
                                                    <v-card-title>
                                                        <span class="headline">{{ $t('EarliestStartDate') }}</span>
                                                    </v-card-title>
                                                    <v-date-picker
                                                        v-model="editedItem.earliest_start_date"
                                                        :locale="$i18n.locale"
                                                    >
                                                    </v-date-picker>
                                                </v-card>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-card>
                                                    <v-card-title>
                                                        <span class="headline">{{ $t('LatestEndDate') }}</span>
                                                    </v-card-title>
                                                    <v-date-picker
                                                            v-model="editedItem.latest_end_date"
                                                            :locale="$i18n.locale"
                                                    >
                                                    </v-date-picker>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-textarea v-model="editedItem.short_description" :label="$t('ShortDescription')"></v-textarea>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-textarea v-model="editedItem.long_description" :label="$t('LongDescription')"></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="close">{{ $t('Cancel') }}</v-btn>
                                    <v-btn color="blue darken-1" text @click="save">{{ $t('Save') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>

                <template v-slot:item.earliest_start_date="{ item }">
                    <span>{{ new Date(item.earliest_start_date).toLocaleDateString() }}</span>
                </template>

                <template v-slot:item.latest_end_date="{ item }">
                    <span>{{ new Date(item.latest_end_date).toLocaleDateString() }}</span>
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item)"
                    >
                        edit
                    </v-icon>
                    <v-icon
                            small
                            @click="deleteItem(item)"
                    >
                        delete
                    </v-icon>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                        <v-card
                                class="mx-auto"
                                outlined
                        >
                            <h3>Översättningar av kort beskrivning</h3>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">{{ $tc('Language', 1) }}</th>
                                            <th class="text-left">{{ $tc('Phrase', 1) }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="translatedPhrase in item.short_description_translations" :key="translatedPhrase.pk">
                                            <td>{{ translatedPhrase.language_description_phrase }}</td>
                                            <td>{{ translatedPhrase.phrase }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>

                        <v-card
                                class="mx-auto"
                                outlined
                        >
                            <h3>Översättningar av lång beskrivning</h3>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th class="text-left">Språk</th>
                                        <th class="text-left">Fras</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="translatedPhrase in item.long_description_translations" :key="translatedPhrase.pk">
                                        <td>{{ translatedPhrase.language_description_phrase }}</td>
                                        <td>{{ translatedPhrase.phrase }}</td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </td>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script lang="ts">
    import axios from "axios";
    import i18n from "../i18n";
    import TicketType from "../core/models/future/TicketType";

    export default {
        name: "TicketTypes",
        data () {
            return {
                dialogShouldBeOpen: false,
                loading: true,
                dialog: false,
                ticket_types: [],
                expanded: [],
                ticket_type_headers :
                    [
                        {text: i18n.t('MinAge'), value: 'min_age'},
                        {text: i18n.t('MaxAge'), value: 'max_age'},
                        {text: i18n.t('ShortDescription'), value: 'short_description_phrase'},
                        {text: i18n.t('LongDescription'), value: 'long_description_phrase'},
                        {text: i18n.t('EarliestStartDate'), value: 'earliest_start_date'},
                        {text: i18n.t('LatestEndDate'), value: 'latest_end_date'},
                        {text: i18n.t('Price'), value: 'price'},
                        {text: i18n.t('VATWithUnit'), value: 'vat_percentage'},
                        {text: i18n.tc('Action', 3), value: 'actions', sortable: false },
                    ],
                editedIndex: -1,
                editedItem: new TicketType(),
                defaultItem: new TicketType(),
            }
        },

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? i18n.t('NewTicketType') : i18n.t('EditTicketType')
            },
        },

        watch: {
            dialogShouldBeOpen (val) {
                val || this.close()
            },
        },

        // TODO: Handle errors
        methods: {
            editItem (item) {
                this.editedIndex = this.ticket_types.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogIsOpen = true
            },

            deleteItem (item) {
                const index = this.ticket_types.indexOf(item)
                if (confirm(i18n.t('AreYouSureYouWantToDeleteThisPost'))){
                    axios
                        .delete('http://localhost:8000/API/TicketType/' + item.pk + '/')
                        .then(response => {
                            if (response.status != 404) {
                                this.ticket_types.splice(index, 1)
                            }
                        })
                }
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save () {
                const currentItemIndex = this.editedIndex;
                this.loading = true
                if (this.editedIndex > -1) {
                    axios
                        .put('http://localhost:8000/API/TicketType/' + this.editedItem.pk + '/', this.editedItem)
                        .then(response => {
                            this.editedItem = response.data
                            Object.assign(this.ticket_types[currentItemIndex], this.editedItem)
                            this.loading = false
                        })
                } else {
                    axios
                        .post('http://localhost:8000/API/TicketType/', this.editedItem)
                        .then(response => {
                            this.editedItem = response.data
                            this.ticket_types.push(this.editedItem)
                            this.loading = false
                        })
                }
                this.close()
            },
        },

        mounted () {
            axios
                .get('http://localhost:8000/API/TicketType/')
                .then(response => {
                    (this.ticket_types = response.data)
                    this.loading = false
                });
        }
    }
</script>

<style scoped>

</style>